import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useFormasDePago() {
  const formasDePago = useQuery({
    queryKey: ["formas-de-pago"],
    queryFn: resourcesService.getFormasDePago,
  });

  return formasDePago;
}
